<template lang="pug">
div
  app-header
    .ObjectsMenu
      b.Menu-title {{ title.toUpperCase() }}
  router-view(v-if='workspace && version && token')
</template>

<script>
import AppHeader from '@/components/AppHeader'
import common from '@/mixins/common'

export default {
  name: 'excel-layers',

  mixins: [common],

  components: {
    AppHeader
  },

  computed: {
    title() {
      if (this.$store.getters.excelLayerSettings) {
        return `Информационный слой: ${this.$store.getters.excelLayerSettings.name}`
      }

      return 'Информационные слои'
    }
  },

  watch: {
    workspaceAndVersion(newVal, oldVal) {
      if ((oldVal.workspace && newVal.workspace !== oldVal.workspace) || (oldVal.version && oldVal.version !== newVal.version)) {
        this.$store.dispatch('clearExcelLayers')
        this.$router.replace('/excel-layers')
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayers.vue